module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commonproblems"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', [_c('div', {
    staticClass: "home_content"
  })]) : _vm._e(), (_vm.props) ? _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('div', {
    staticClass: "home_banner"
  }, [_c('div', {
    staticClass: "outerwrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Header'), _c('div', {
    attrs: {
      "id": "content_center"
    }
  }, [_c('div', {
    staticClass: "concent"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "home-content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('Sidebar')], 1)])])])], 1), _c('Footer')], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03746b48","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/common-problems/common-problems.pug
// module id = 567
// module chunks = 1